// store text options for ease of access/change
// these are now merged with user settings and stored in state
import c from './u-colours';

// array of pay
const opts = {
    vc: { // does not have a scatter chart
        squareChart: {
            id: '#js-square0',
            key: 'vc_pay',
            fColour: c.crimson
        }
    },
    salary: {
        id: '#point-series',
        xAxisLabel: null,
        yAxisLabel: null,
        xKey: null,
        yKey: null,
        xScale: d3.scale.linear(),
        colour: c.crimsonDark,
        footnote: null,
        title: null,
        snap: null,
        squareChart: {
            id: '#js-square1',
            key: null,
            fColour: c.crimsonDark
        }
    },
    ref: {
        id: '#point-series',
        xAxisLabel: null,
        yAxisLabel: null,
        xKey: null,
        yKey: null,
        xScale: d3.scale.linear(),
        colour: c.lilacDark,
        footnote: null,
        title: null,
        snap: null,
        squareChart: {
            id: '#js-square2',
            key: null,
            fColour: c.lilacDark
        }
    },
    nss: {
        id: '#point-series',
        xAxisLabel: null,
        yAxisLabel: null,
        xKey: null,
        yKey: null,
        xScale: d3.scale.linear(),
        colour: c.limeDark,
        footnote: null,
        title: null,
        squareChart: {
            id: '#js-square3',
            key: null,
            fColour: c.limeDark
        }
    },
    students: {
        id: '#point-series',
        xAxisLabel: null,
        yAxisLabel: null,
        xKey: null,
        yKey: null,
        xScale: d3.scale.linear(),
        colour: c.orangeDark,
        footnote: null,
        title: 'V-c pay vs institution¹s size',
        snap: null,
        squareChart: {
            id: '#js-square4',
            key: null,
            fColour: c.orangeDark
        }
    }
};

export default opts;